import { Link } from 'react-router-dom';

export function PublicFooter({ completo = false }: { completo?: boolean }) {
  if (!completo) {
    return (
      <footer className="bg-wood-dark text-border py-8 px-4 sm:px-6 md:px-14 text-xs text-center">
        © {new Date().getFullYear()} Santtesanía. Todos los derechos reservados.
      </footer>
    );
  }

  return (
    <footer className="bg-wood-dark text-border pt-12 pb-7 px-4 sm:px-6 md:px-14 flex flex-col gap-7">
      <div className="max-w-[1280px] mx-auto w-full flex flex-col gap-7">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="flex flex-col gap-2.5 max-w-xs">
            <div className="font-display text-2xl font-bold text-white">Santtesanía</div>
            <p className="text-[13px] leading-relaxed">
              Artículos religiosos y artesanía peruana, hechos con devoción para tu hogar, tu regalo o tu
              negocio.
            </p>
          </div>
          <div className="flex flex-wrap gap-x-10 gap-y-6 md:gap-16">
            <div className="flex flex-col gap-2.5">
              <div className="text-xs font-bold uppercase tracking-wide text-gold">Tienda</div>
              <Link to="/catalogo" className="text-[13px]">
                Catálogo
              </Link>
              <Link to="/sobre-nosotros" className="text-[13px]">
                Sobre Nosotros
              </Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <div className="text-xs font-bold uppercase tracking-wide text-gold">Ayuda</div>
              <Link to="/faq" className="text-[13px]">
                Preguntas Frecuentes
              </Link>
              <Link to="/politica-de-envios" className="text-[13px]">
                Política de Envíos y Pagos
              </Link>
              <Link to="/terminos" className="text-[13px]">
                Términos y Condiciones
              </Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <div className="text-xs font-bold uppercase tracking-wide text-gold">Contacto</div>
              <Link to="/contacto" className="text-[13px]">
                Escríbenos por WhatsApp
              </Link>
              <div className="text-[13px]">Perú</div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-4 text-xs">
          © {new Date().getFullYear()} Santtesanía. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
